import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer__container">
        <div className="footer__info">
          <span className="footer__subtitle">Find me on</span>

          <div className="footer__section">
            <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://instagram.com/rmzysptra"
            >
              <i className="fab fa-instagram"></i> Instagram
            </a>

            <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://github.com/rmzysptra"
            >
              <i className="fab fa-github"></i> GitHub
            </a>
            
            <a
              target="_blank"
              rel="noreferrer noopener"
              href="https://tiktok.com/@rmzysptra"
            >
              <i className="fab fa-tiktok"></i> TikTok
            </a>

            <a
              target="_blank"
              rel="noreferrer noopener"
              href="mailto:example@gmail.com"
            >
              <i className="fas fa-envelope"></i> Email
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;